<!-- seguimiento-form-modal.component.html -->
<div class="modal-header bg-primary text-white">
  <h5 class="modal-title">
    <i class="icofont icofont-clipboard me-1"></i>
    {{ modoEdicion ? 'Editar seguimiento' : 'Nuevo seguimiento' }}
  </h5>
  <button type="button" class="btn-close btn-close-white" (click)="cerrar()"></button>
</div>

<form [formGroup]="form" (ngSubmit)="guardar()" novalidate>
  <div class="modal-body">
    <div class="row g-3">
      <div class="col-md-6">
        <label class="form-label fw-semibold text-dark">
          <i class="icofont icofont-calendar me-1"></i>Fecha seguimiento: <span class="text-danger">*</span>
        </label>
        <input type="date" class="form-control" formControlName="fecha_seguimiento">
      </div>

      <div class="col-md-6">
        <label class="form-label fw-semibold text-dark"><i class="icofont icofont-business-man me-1"></i>Responsable:</label>
        <ng-select [items]="colaboradores" bindLabel="nombreCompleto" bindValue="cedula"
          [compareWith]="compararPorCedula" [loading]="cargandoColaboradores" placeholder="Seleccione..."
          formControlName="responsable_seguimiento">
        </ng-select>
      </div>

      <div class="col-md-12">
        <label class="form-label fw-semibold text-dark"><i class="icofont icofont-notepad me-1"></i>Observación:</label>
        <textarea class="form-control" rows="3" formControlName="observacion"></textarea>
      </div>

      <div class="col-md-12">
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" role="switch" formControlName="cumplido" id="chkCumplido">
          <label class="form-check-label fw-semibold text-dark" for="chkCumplido">¿Acción cumplida?</label>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="cerrar()" [disabled]="guardando">
      <i class="icofont icofont-close me-1"></i>Cancelar
    </button>
    <button type="submit" class="btn btn-primary" [disabled]="guardando">
      <span *ngIf="!guardando">
        <i class="icofont icofont-save me-1"></i>{{ modoEdicion ? 'Actualizar' : 'Guardar' }}
      </span>
      <span *ngIf="guardando">
        <span class="spinner-border spinner-border-sm me-1"></span>
        {{ modoEdicion ? 'Actualizando...' : 'Guardando...' }}
      </span>
    </button>
  </div>
</form>